// src/components/common/ModernSelect.jsx

import React from 'react';
import { ChevronDown } from 'lucide-react';

const ModernSelect = ({ 
    label, 
    name, 
    value, 
    onChange, 
    options, 
    placeholder, // ⭐ FIX 1: Added placeholder to the destructured props
    required = false, 
    labelStyle,
    borderColor,
    borderWidth,
    borderStyle,
    inputBackgroundColor,
    inputTextColor,
    borderRadius,
    disabled = false,
    helpText
}) => {
    const selectStyle = {
        borderColor: borderColor || undefined,
        borderWidth: borderWidth ? `${borderWidth}px` : undefined,
        borderStyle: borderStyle || undefined,
        backgroundColor: inputBackgroundColor || undefined,
        color: inputTextColor || undefined,
        borderRadius: borderRadius || undefined,
    };

    return (
        <div className="mb-4 relative">
            {label && (
                <label 
                    htmlFor={name} 
                    className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1.5 tracking-tight" 
                    style={labelStyle}
                >
                    {label} {required && <span className="text-rose-500">*</span>}
                </label>
            )}
            
            <div className="relative group">
                <select
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className={`appearance-none w-full pl-3 pr-10 py-2.5 
                               text-sm font-medium text-slate-800 dark:text-slate-200 
                               bg-white dark:bg-slate-900 
                               border border-slate-200 dark:border-slate-700 
                               rounded-xl shadow-sm
                               focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500
                               transition-all duration-200 ease-in-out
                               disabled:bg-slate-50 dark:disabled:bg-slate-800/80 disabled:text-slate-400 dark:disabled:text-slate-500 disabled:cursor-not-allowed`}
                    style={selectStyle}
                    required={required}
                    disabled={disabled}
                >
                    {/* ⭐ FIX 2: Added the hidden placeholder option */}
                    {placeholder && (
                        <option value="" disabled hidden>
                            {placeholder}
                        </option>
                    )}

                    {(options || []).map(option => (
                        <option key={option.value} value={option.value} disabled={option.disabled}>
                            {option.label}
                        </option>
                    ))}
                </select>
                
                <div className={`absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none transition-colors duration-200 ${disabled ? 'text-slate-300 dark:text-slate-600' : 'text-slate-400 group-hover:text-indigo-500'}`}>
                    <ChevronDown size={16} />
                </div>
            </div>

            {helpText && (
                <p className="mt-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                    {helpText}
                </p>
            )}
        </div>
    );
};

export default ModernSelect;